import { TranslationKey } from "../translations"

export interface ComplementaryField {
    name: string
    label: TranslationKey
}

export type ComplementaryAnswer = {
    [key: string]: string
}

export interface Answer {    
    title: TranslationKey
    value: string
    tooltipTranslationKey?: TranslationKey; // Only used for radio buttons at the moment
    followQuestion?: BaseQuestion['id']
    ignoreQuestion?: BaseQuestion['id']
    readonly complementaryFields?: ComplementaryField[]
}

export type QuestionType = 'radio' | 'checkbox' | 'text-input'

export enum QuestionStatus {
    Answered = 'ANSWERED',
    NotAnswered = 'NOT_ANSWERED',
    Skip = 'SKIP'
}

export interface BaseQuestion {
    readonly id: number
    readonly heading: TranslationKey
    readonly description?: TranslationKey
    readonly question: TranslationKey
    readonly type: QuestionType
    readonly key: string,
    status: QuestionStatus,
    givenAnswer: string | null,
    complementaryAnswers?: ComplementaryAnswer
    hideQuestionTitle?: boolean
    previousId?: number; // Id of the question answered before
    category: QuestionCategory;
}

export interface RadioQuestion extends BaseQuestion {
    readonly type: 'radio'
    readonly possibleAnswers: Answer[]
}

export interface FreeTextQuestion extends BaseQuestion {
    readonly type: 'text-input'
    readonly possibleAnswers: null
}

export type Question = RadioQuestion | FreeTextQuestion

export type QuestionCategory = 'work' | 'education';

